/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Layout from "../../../../Layouts/Layout";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import PartnerLogoSection from "../../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import Container from "../../../../../components/Container/Container";
import AttorneySection from "../../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import LpAdvocardMeta from "./LpAdvocardMeta";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { contractTeaserCards } from "@/src/services/landingPageService";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import EmploymentLawCheckIn from "../../../../../components/Checkin/EmploymentLawCheckIn/EmploymentLawCheckIn";
import HowItWorksSectionEmploymentLaw from "../../../../../components/Sections/EmploymentLaw/HowItWorksSection/HowItWorksSectionEmploymentLaw";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";

const LpContractAdvocard = () => {
  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpAdvocardMeta
        title={"Professionelle Hilfe im Arbeitsrecht | Legalbird"}
        description={"Professionelle Hilfe im Arbeitsrecht - Schnell, einfach und sicher! Jetzt beraten lassen!"}
      />
      <LandingPageTeaser
        teaserButtonText={"Jetzt starten"}
        headline={"Fragen oder Probleme bei rechtlichen Streitigkeiten im Arbeitsrecht?"}
        subheadline={"Wir sorgen dafür, dass Sie zu Ihrem Recht gelangen!"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={contractTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={PARTNER_IRIS.ADVOCARD} containerStyle={"settlementContainer"} />
      {!isLoggedIn && (
        <Container>
          <EmploymentLawCheckIn idPrefix={"top"} partner={PARTNER_IRIS.ADVOCARD} />
        </Container>
      )}
      <HowItWorksSectionEmploymentLaw />
      <AttorneySection
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        heading={"Deutschlandweit tätige Partneranwälte"}
      />
      {!isLoggedIn && (
        <Container>
          <EmploymentLawCheckIn idPrefix={"top"} partner={PARTNER_IRIS.ADVOCARD} />
        </Container>
      )}
    </Layout>
  );
};

export default LpContractAdvocard;
